export var LogsToMetricsSubject;
(function (LogsToMetricsSubject) {
    LogsToMetricsSubject["Container"] = "l2m-container";
    LogsToMetricsSubject["DefinitionsPage"] = "l2m-definitions-page";
    LogsToMetricsSubject["EditPage"] = "l2m-edit-page";
    LogsToMetricsSubject["Form"] = "l2m-form";
    LogsToMetricsSubject["Table"] = "l2m-table";
    LogsToMetricsSubject["EmptyState"] = "l2m-empty-state";
    LogsToMetricsSubject["RuleNameInput"] = "l2m-rule-name-input";
    LogsToMetricsSubject["DimensionFieldSelect"] = "l2m-dimension-field-select";
    LogsToMetricsSubject["CountLogsCheckbox"] = "l2m-count-logs-checkbox";
    LogsToMetricsSubject["AggregateFieldCheckbox"] = "l2m-aggregate-field-checkbox";
    LogsToMetricsSubject["FieldHistogramCheckbox"] = "l2m-field-histogram-checkbox";
    LogsToMetricsSubject["AggregationMethodSelect"] = "l2m-aggregation-method-select";
    LogsToMetricsSubject["AggregationFieldSelect"] = "l2m-aggregation-field-select";
    LogsToMetricsSubject["DescriptionInput"] = "l2m-description-input";
    LogsToMetricsSubject["LabelKeyInput"] = "l2m-label-key-input";
    LogsToMetricsSubject["LabelValueInput"] = "l2m-label-value-input";
    LogsToMetricsSubject["MetricsAccountSelect"] = "l2m-metrics-account-select";
    LogsToMetricsSubject["SaveRuleButton"] = "l2m-save-rule-button";
    LogsToMetricsSubject["EnableRuleNotification"] = "l2m-enable-rule-notification";
    LogsToMetricsSubject["DisableRuleNotification"] = "l2m-disable-rule-notification";
    LogsToMetricsSubject["CreateBlockedInlineNotification"] = "l2m-create-blocked-inline-notification";
})(LogsToMetricsSubject || (LogsToMetricsSubject = {}));
export var LogsToMetricsAggregationMethod;
(function (LogsToMetricsAggregationMethod) {
    LogsToMetricsAggregationMethod["Avg"] = "AVG";
    LogsToMetricsAggregationMethod["Max"] = "MAX";
    LogsToMetricsAggregationMethod["Min"] = "MIN";
    LogsToMetricsAggregationMethod["Sum"] = "SUM";
})(LogsToMetricsAggregationMethod || (LogsToMetricsAggregationMethod = {}));
//# sourceMappingURL=logs-to-metrics.enum.js.map